import { isEmpty } from "lodash";
import { Grid } from "semantic-ui-react";
import { useGetAllFacilitiesForSearch } from "../../api/cultivations";
import { FacilityType } from "../../config/enums/FacilityType.enum";
import { IngredientDataTypesOption } from "../../config/enums/IngredientType.enum";
import SearchWithButton from "../dropdownWithButton/SearchWithButton";
import { InputText } from "../InputText/InputText";
import { DropDown } from "../selectDropDown/DropDown";
import { TitleView } from "../titleView/TitleView";

const SimulationProcessingDetails = ({
  register,
  processTypesWholeList,
  processingType,
  setProcessingType,
  setValue,
  facilityName,
  facilityWholeList,
  setFacilityName,
  originalProcessData,
  dataTypeOptions,
  dataType,
  setDataType,
  setVisibleFacilityDetailsModal
}: any) => {
  const disableProcess = isEmpty(originalProcessData?.processingName) ? false : true;

  const { availableFacilities } = useGetAllFacilitiesForSearch(FacilityType.FACTORY);
  const customResultTextView = (title: string) => <p className={"searchResultText"}>{title}</p>;

  const getSearchValue = (value: any) => {
    setFacilityName(value?.result?.id);
    setValue("facilityName", value?.result?.id);
    return null;
  };

  return (
    <>
      <TitleView title="Processing Details" />
      <Grid>
        <Grid.Row divided>
          <Grid.Column computer={8} tablet={8} mobile={8}>
            <Grid.Column computer={8} tablet={8} mobile={8}>
              <p>Processing Name</p>
              <p>{originalProcessData?.processingName}</p>
            </Grid.Column>
            <Grid.Column computer={8} tablet={8} mobile={8} className="tw-mt-1">
              <p>Processing Type</p>
              <p>
                {
                  processTypesWholeList?.find(
                    (types: any) => originalProcessData?.processingType == types?.value
                  )?.text
                }
              </p>
            </Grid.Column>
            <Grid.Column computer={8} tablet={8} mobile={8} className="tw-mt-1">
              <p>Facility Name</p>
              <p>
                {
                  facilityWholeList?.find(
                    (types: any) => originalProcessData?.facilityId == types?.value
                  )?.text
                }
              </p>
            </Grid.Column>
            <Grid.Column computer={8} tablet={8} mobile={8} className="tw-mt-1 tw-mb-2">
              <p>Machine Model Number</p>
              <p>{originalProcessData?.machineModelNo}</p>
            </Grid.Column>
          </Grid.Column>
          <Grid.Column computer={8} tablet={8} mobile={8}>
            <Grid.Column computer={8} tablet={8} mobile={16}>
              <Grid.Column computer={8} tablet={8} mobile={16} className="paddingRemoveTop">
                <InputText
                  register={register}
                  labelName={"Process Name"}
                  placeholder="Process Name"
                  name={`processingName`}
                  disabled={disableProcess}
                  required={true}
                  errorMessage={"Process name is required"}
                />
              </Grid.Column>
              <DropDown
                labelName={"Processing Type"}
                placeholder="Select Type"
                currentData={processTypesWholeList}
                defaultValue={processingType}
                customGridColumn={"customGridColomnTyp"}
                handleChangeState={(e: any, { value }: any) => {
                  setProcessingType(value);
                  setValue("processingType", value);
                }}
              />
            </Grid.Column>
            <Grid.Column computer={8} tablet={8} mobile={16} className="paddingRemoveTop">
              <DropDown
                labelName={"Data Type*"}
                currentData={dataTypeOptions}
                placeholder="Select Data Type"
                defaultValue={dataType || IngredientDataTypesOption.SPECIFIC}
                customGridColumn={"customGridColomnTyp"}
                handleChangeState={(e: any, { value }: any) => {
                  setDataType(value);
                  setValue("dataType", value);
                }}
              />
            </Grid.Column>
            <Grid.Column computer={8} tablet={8} mobile={16} className="paddingRemoveTop">
              <SearchWithButton
                labelName="Facility Name*"
                placeholder="Select Facility Name"
                currentData={availableFacilities}
                defaultValue={facilityName}
                errorMessage="Facility name is required"
                getSearchValue={getSearchValue}
                buttonTitle="View"
                buttonTheme="grey"
                buttonDisabled={!facilityName}
                buttonOnClick={() => setVisibleFacilityDetailsModal(true)}
                customResultTextView={customResultTextView}
              />
            </Grid.Column>
            <Grid.Column computer={8} tablet={8} mobile={16} className="paddingRemoveTop">
              <InputText
                register={register}
                labelName={"Machine Model Number"}
                placeholder="Machine Model Number"
                name={`machineModelNo`}
              />
            </Grid.Column>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
};

export default SimulationProcessingDetails;
